import { render, staticRenderFns } from "./VTabItem.vue?vue&type=template&id=06697248&scoped=true&"
import script from "./VTabItem.vue?vue&type=script&lang=js&"
export * from "./VTabItem.vue?vue&type=script&lang=js&"
import style0 from "./VTabItem.vue?vue&type=style&index=0&id=06697248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06697248",
  null
  
)

export default component.exports